module.exports = __webpack_public_path__ + "img/wechat-img1.d4ee74c7.png";